const React = require("react");
const {ConfigRouter} = require("../../../../../dumb/AdminHelpers/AdminConfigs");

const TrxProcessing = require('./components/TrxProcessing');
const RetailersFee = require('./components/RetailersFee');
const CustomersFee = require('./components/CustomersFee');

module.exports = () => (
  <ConfigRouter
    links={[
      // {id: 'limits', title: 'Limits'},
      {id: 'trxProcessing', title: 'Transaction Processing'},
      {id: 'retailersFee', title: 'Retailers Fee'},
      {id: 'customersFee', title: 'Customers Fee'},
      // {id: 'notification', title: 'Notifications'},
    ]}
    views={{
      trxProcessing: TrxProcessing,
      retailersFee: RetailersFee,
      customersFee: CustomersFee,
    }}
  />
)
